import { Box, Typography } from "@mui/material";
import useGetCompanyLogo from "app/hooks/company/useGetCompanyLogo";
import { convertToBase64, getInitialsOfName } from "app/utils/utils";

const SquareImage = ({
  companyLogo,
  companyId,
  companyName,
  width = 50,
  height = 50,
  imgStyle = {}
}) => {
  const shouldFetchLogo = !companyLogo && !!companyId;
  const { data: logo } = useGetCompanyLogo({ companyId, enabled: shouldFetchLogo });

  const imageData = companyLogo || (logo && logo.jp_logo);

  return (
    <div>
      {imageData ? (
        <img
          src={`data:image/jpeg;base64,${convertToBase64(imageData.data)}`}
          alt="Logo"
          width={width}
          height={height}
          style={{
            padding: "0px",
            objectFit: "contain",
            background: "white",
            borderRadius: "5px",
            width,
            height,
            ...imgStyle
          }}
        />
      ) : (
        <Box
          sx={{
            cursor: "pointer",
            bgcolor: "#222a45",
            width,
            height,
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "5px"
          }}
        >
          <Typography variant={"h6"}>{getInitialsOfName(companyName)}</Typography>
        </Box>
      )}
    </div>
  );
};

export default SquareImage;
